import { animate, scroll, inView, stagger } from "motion";
import Swiper from 'swiper/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const blockStatistics = document.querySelectorAll('.block-statistics');
    let swiperInstance = null;  // Declare a variable to store the Swiper instance

    // Check if the showcase block exists
    if (blockStatistics.length === 0) {
        return;
    }

    // Initialize Swiper on page load
    blockStatistics.forEach(component => {
        initSwiper(component);
        animations(component);
    });

    function initSwiper(component) {
        const blockStatisticsWrapper = component.querySelector('.block-statistics__wrapper');

        if (window.innerWidth <= 1024) {
            // If it's a mobile screen, add the swiper classes dynamically
            if (!blockStatisticsWrapper.classList.contains('swiper') && !blockStatisticsWrapper.querySelector('.swiper-wrapper')) {
                blockStatisticsWrapper.classList.add('swiper');
                blockStatisticsWrapper.innerHTML = `
                    <div class="swiper-wrapper">
                        ${blockStatisticsWrapper.innerHTML}
                    </div>
                `;
            }

            // Initialize Swiper only if it hasn't been initialized yet
            if (!swiperInstance) {
                swiperInstance = new Swiper(blockStatisticsWrapper, {
                    clickable: true,
                    loop: true,
                    spaceBetween: 15,
                    slidesPerView: 1.25,
                    centeredSlides: true,
                });
            }
        } else {
            // If it's desktop, remove swiper and clean up
            if (swiperInstance) {
                swiperInstance.destroy(true, true); // Destroy Swiper instance
                swiperInstance = null; // Reset the instance variable
            }
            blockStatisticsWrapper.classList.remove('swiper');
            const swiperWrapper = blockStatisticsWrapper.querySelector('.swiper-wrapper');
            if (swiperWrapper) {
                blockStatisticsWrapper.innerHTML = swiperWrapper.innerHTML; // Clean up the swiper structure
            }
        }
    }

    function animations(component) {
        const blockStatisticsContent = component.querySelectorAll('.block-statistics__content > *');
        const blockStatisticsBlocks = component.querySelectorAll('.block-statistics__block');
        const blockStatisticsStatistic = component.querySelectorAll('.block-statistics__block__statistic');

        // Animations for content
        inView(component, () => {
            if (blockStatisticsContent) {
                animate(blockStatisticsContent, 
                    { 
                        opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
                        transform: ['translateY(60px)', 'translateY(0)'], // Slide up (translateY transition).
                    }, 
                    { 
                        duration: 0.6, // Animation duration.
                        delay: stagger(0.25, { startDelay: 0.6 }) // Delay before animation starts.
                    }
                );
            }

            // Add scroll animation only for desktop view
            if (window.innerWidth >= 768) {
                scroll(
                    animate(component.querySelector('.block-statistics__content'), 
                        { y: [0, -250] },  // Move the heading from 0 to -10px along the Y-axis.
                        { ease: "ease-in-out" } // Easing.
                    )
                );
            }

            if (blockStatisticsBlocks) {
                animate(blockStatisticsBlocks, 
                    { 
                        opacity: [0, 1], // Fade in (opacity transition from 0 to 1).
                        transform: ['translateY(60px)', 'translateY(0)'], // Slide up (translateY transition).
                    }, 
                    { 
                        duration: 0.6, // Animation duration.
                        delay: stagger(0.25, { startDelay: 0.9 }) // Delay before animation starts.
                    }
                );
            }

            // Animations for statistics count
            blockStatisticsStatistic.forEach(statistic => {
                const dataCountElement = statistic;
                const dataCount = dataCountElement.getAttribute('data-count').toString();
            
                // Extract the symbol only if the last character is not a digit or a dot
                let symbol = '';
                const lastChar = dataCount.slice(-1);
                if (isNaN(parseInt(lastChar)) && lastChar !== '.') {
                    symbol = lastChar;
                }
            
                const numericValue = parseFloat(dataCount);  // Works regardless of trailing symbol
            
                if (!isNaN(numericValue)) {
                    animate(0, numericValue, {
                        delay: 1,
                        duration: 2,
                        ease: "circOut",
                        onUpdate: (latest) => {
                            dataCountElement.innerHTML = Math.round(latest) + symbol;
                        }
                    });
                }
            });
        }, {
            amount: 0.2 // Trigger when 20% of the element is visible
        });
    }

    // Add an event listener to handle window resizing
    window.addEventListener('resize', () => {
        blockStatistics.forEach(component => {
            initSwiper(component);  // Reinitialize Swiper based on new window size
        });
    });
});